angular.module('app').filter("dateFilter", function () {
    return function (items, from, to) {
        if (to == null) {
            return items;
        }
        if (from == null) {
            return items;
        }

        var df = from;
        var dt = to;
        var result = [];

        for (var i = 0; i < items.length; i++) {
            var itemEventDate = items[i].EventStartDate;

            if (itemEventDate >= df && itemEventDate <= dt) {
                result.push(items[i]);
            }
        }
        return result;
    };
});


//////////////////
// WEBPACK FOOTER
// ./static/common/js/filter/_dateFilter.js
// module id = 10
// module chunks = 0